import { render, staticRenderFns } from "./LoversCustom.vue?vue&type=template&id=0b85558d&scoped=true"
import script from "./LoversCustom.vue?vue&type=script&lang=js"
export * from "./LoversCustom.vue?vue&type=script&lang=js"
import style0 from "./LoversCustom.vue?vue&type=style&index=0&id=0b85558d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85558d",
  null
  
)

export default component.exports